import { render, staticRenderFns } from "./FAQ001M01.vue?vue&type=template&id=0ff7bb20&"
import script from "./FAQ001M01.vue?vue&type=script&lang=js&"
export * from "./FAQ001M01.vue?vue&type=script&lang=js&"
import style0 from "./FAQ001M01.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports